export const routes = {
    main: '/',
}
